export default {
  transition: 1, // in second
  baselineWidth: 0.01, // vh;
  characterOffset: 0.25, // vh;
  fadeDuration: 500, // ms
};
